import { AfterViewInit, Component } from '@angular/core';

@Component({
    selector: 'app-career-competencies-breadcrumb',
    templateUrl: './career-competencies-breadcrumb.component.html',
    standalone: false
})
export class CareerCompetenciesBreadcrumbComponent implements AfterViewInit {

  ngAfterViewInit(): void {
    document.getElementById('custom-breadcrumb').style.width =
      document.querySelector('.lpx-topbar').clientWidth + 'px';
  }
}
